const { cookiesList, consentCategories } = require('./constants');

const getNonEssentialValuesOf = (cookieName) => {
  const cookie = cookiesList.find((item) => item.name === cookieName);

  if (!cookie || !cookie.permissions) {
    return [];
  }

  return Object.keys(cookie.permissions)
    .filter((value) => cookie.permissions[value] !== consentCategories.ESSENTIAL);
};

const getSanitizableCookies = () => cookiesList.filter((cookie) => cookie.sanitizer);

const getNonEssentialCookies = () => cookiesList
  .filter((cookie) => cookie.permission !== consentCategories.ESSENTIAL);

module.exports = {
  getNonEssentialValuesOf,
  getNonEssentialCookies,
  getSanitizableCookies,
};
